import { render, staticRenderFns } from "./languages-block.vue?vue&type=template&id=58e71fc0"
import script from "./languages-block.vue?vue&type=script&lang=ts"
export * from "./languages-block.vue?vue&type=script&lang=ts"
import style0 from "./languages-block.vue?vue&type=style&index=0&id=58e71fc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports